/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import cx from 'classnames';

import { AuthWrapper } from '@flow';
import { Button, CustomLink, Input } from '@components';
import URL from '@helpers/url-constant';
import { forgotPassword } from '@apis/Auth';

import sty from '@flow/AuthWrapper/auth.module.scss';
import { useTheme } from '@context/ThemeProvider';

const TOTAL_FIELD = 1; // how many required field

function ForgotPassword() {
  const { client = 'payment-loyalty', clientConfig } = useTheme();
  const [email, handleEmail] = useState('');
  const [isFormPristine, handleFormPristine] = useState(true);
  const [loading, handleLoading] = useState(false);

  // for form submission
  const [hasError, handleHasError] = useState({});
  const [fieldCount, handleFieldCount] = useState(0);
  const [canSubmit, handleCanSubmit] = useState(false);

  const [forgotPwdStatus, handleForgotPwdStatus] = useState({
    status: true,
    message: '',
  });

  useEffect(() => {
    async function forgotPwdApiCall() {
      handleLoading(true);

      const { status, message } = await forgotPassword({ email });
      handleForgotPwdStatus({ status, message });
      handleLoading(false);
    }
    if (canSubmit && fieldCount >= TOTAL_FIELD && !Object.keys(hasError).length) {
      forgotPwdApiCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canSubmit, fieldCount, hasError]);

  useEffect(() => {
    if (forgotPwdStatus.message) {
      handleForgotPwdStatus({ status: true, message: '' });
    }
    handleCanSubmit(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  function handleError({ name, value }) {
    const errors = { ...hasError };

    if (!isFormPristine) {
      handleFieldCount(state => (state === TOTAL_FIELD ? TOTAL_FIELD : state + 1));
    }
    if (value) {
      errors[name] = 'error';
    } else {
      delete errors[name];
    }

    handleHasError(errors);
  }

  function validateForm(e) {
    e.preventDefault();

    if (isFormPristine) {
      handleFormPristine(false);
    }

    handleCanSubmit(true);
  }

  const { status, message } = forgotPwdStatus;

  return (
    <AuthWrapper
      pageTitle="Forgot Password"
      msg="Forgot Password"
      showLoading={loading}
      theme={{
        brandLogo: clientConfig.logo,
        bgColor: clientConfig.background,
        headerColor: clientConfig.onBackground,
        welcomeImg: clientConfig.welcomeImg,
        welcomeImgWebp: clientConfig.welcomeImgWebp,
      }}
    >
      {!status && (
        <div className="alert alert-danger" role="alert">
          {message}
        </div>
      )}

      {status && message && (
        <div className="alert alert-success" role="alert">
          {message}
        </div>
      )}
      <form onSubmit={validateForm}>
        <Input
          type="email"
          name="email"
          placeholder="Email Address"
          icon="/images/ic_email.svg"
          validations={[
            {
              validation: /(.*[A-Za-z0-9]){1}/i,
              message: 'Please enter email address',
            },
            {
              validation:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: 'Invalid Email',
            },
          ]}
          pristine={isFormPristine}
          onChange={value => handleEmail(value)}
          onError={errorValue => handleError(errorValue)}
        />
        <div className={sty.msg} style={{ color: clientConfig.onBackground }}>
          Enter your email address and click reset password, you will receive an email that contains
          a link to reset your password.
        </div>

        <Button
          className={cx(sty['edit-actions'], { 'edit-actions': loading })}
          type={1}
          colorType={2}
          btnType="submit"
          label={loading ? 'Loading...' : 'Continue'}
          btnCustomStyle={{
            backgroundColor: clientConfig.primaryButtonColor,
            color: clientConfig.onPrimaryButton,
          }}
        />
      </form>
      <div className={sty['link-wrap']} style={{ color: clientConfig.onBackground }}>
        Already got an account?
        <CustomLink
          href={URL.LOGIN}
          color="blue"
          size="font-sm"
          text="Login here"
          customStyle={{ color: clientConfig.linkColor }}
        />
      </div>
    </AuthWrapper>
  );
}

export default ForgotPassword;
